module.exports = __webpack_public_path__ + "img/feature-tile-icon-07.4cef2f03.svg";